export default {
  get(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/sales/products?${queryString}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setProducts", results);
          context.commit("setPagination", {
            count,
            next,
            previous
          });
          resolve(results);
        })
        .catch(reject);
    });
  },
  post(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/sales/products", params)
        .then(response => {
          context.commit("setProduct", response.data);
          resolve(response);
        })
        .catch(reject);
    });
  },
  duplicate(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`/sales/products/${id}/duplicate`)
        .then(resolve)
        .catch(reject);
    });
  },
  put(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .put(`/sales/products/${params.id}`, params)
        .then(response => {
          context.commit("setProduct", response.data);
          resolve(response);
        })
        .catch(reject);
    });
  },
  delete(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`/sales/products/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  getCategories(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/sales/categories?limit=1000", params)
        .then(response => {
          context.commit("setCategories", response.data.results);
          resolve(response);
        })
        .catch(reject);
    });
  },
  getPaymentMethods(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/sales/payment-methods", params)
        .then(response => {
          context.commit("setPaymentMethods", response.data.results);
          resolve(response);
        })
        .catch(reject);
    });
  },
  getCurrency(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/sales/currency", params)
        .then(response => {
          const currencies = [];
          for (let id in response.data) {
            currencies.push({ id, name: response.data[id] });
          }
          context.commit("setCurrencies", currencies);
          resolve();
        })
        .catch(reject);
    });
  },
  getProduct(context, id) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/sales/products/${id}`)
        .then(response => {
          context.commit("setProduct", {});
          context.commit("setProduct", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },

  getCoupons(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/sales/coupon?${queryString}`)
        .then(({ data: { results, next, previous, count } }) => {
          context.commit("setCoupons", results);
          context.commit("setPagination", { next, previous, count });
          resolve({ results, next, previous, count });
        })
        .catch(reject);
    });
  },
  postCoupon(context, data) {
    return new Promise((resolve, reject) => {
      return window.axios
        .post(`/sales/coupon`, data)
        .then(resolve)
        .catch(reject);
    });
  },
  getCoupon(context, coupon_id) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/sales/coupon/${coupon_id}`)
        .then(({ data }) => {
          context.commit("setCoupon", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  editCoupon(context, data) {
    return new Promise((resolve, reject) => {
      return window.axios
        .put(`/sales/coupon/${data.id}`, data)
        .then(resolve)
        .catch(reject);
    });
  },
  getGatewayProviders(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/gateways/providers", params)
        .then(response => {
          context.commit("setGatewayProviders", response.data);
          resolve(response);
        })
        .catch(reject);
    });
  }
};
